/* eslint-disable @typescript-eslint/no-unused-vars */
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import {
  authReducer,
  businessReducer,
  drawerReducer,
  inquiryReducer,
  modalReducer,
  reviewReducer,
  reviewRequestReducer,
  snackbarReducer,
  studioReducer,
  subscriptionReducer,
} from './features';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import { AuthReducerProps } from './features/auth/type';
import { ReviewRequestReducerProps } from './features/review-request/type';

const authPersistConfig: {
  key: string;
  storage: any;
  blackList: (keyof AuthReducerProps)[];
} = {
  key: 'auth',
  storage,
  blackList: ['user', 'authState'],
};

const reviewRequestPersistConfig: {
  key: string;
  storage: any;
  blackList: (keyof ReviewRequestReducerProps)[];
} = {
  key: 'review_request',
  storage,
  blackList: ['requests'],
};

const persistConfig = {
  key: 'root',
  storage,
};

const reducer = combineReducers({
  auth: authReducer,
  business: businessReducer,
  review: reviewReducer,
  reviewRequest: reviewRequestReducer,
  modal: modalReducer,
  snackbar: snackbarReducer,
  studio: studioReducer,
  inquiry: inquiryReducer,
  drawer: drawerReducer,
  subscription: subscriptionReducer,
});

// const persistedReducer = persistReducer(persistConfig, reducer);

export const store = configureStore({
  reducer: reducer,
  devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof reducer>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useSnackbarState = () => useAppSelector(state => state.snackbar);
export const useModalState = () => useAppSelector(state => state.modal);
export const useAuthState = () => useAppSelector(state => state.auth);
export const useBusinessState = () => useAppSelector(state => state.business);
export const useReviewState = () => useAppSelector(state => state.review);
export const useReviewRequestState = () => useAppSelector(state => state.reviewRequest);
export const useStudioState = () => useAppSelector(state => state.studio);
export const useInquiryState = () => useAppSelector(state => state.inquiry);
export const useDrawerState = () => useAppSelector(state => state.drawer);
export const useSubscriptionState = () => useAppSelector(state => state.subscription);
